import React, { useEffect } from 'react'
import useForm from '../hooks/useForm.js'
import { useNavigate } from "react-router-dom";
import { createApiEndpoint } from '../index.js'
import { MuiMaterials } from '../@index.js';
import * as global from '../data/global';
import { useAuth } from "../provider/authProvider";
import { WindowChrome, ModalBody, ModalContentTile, outlinedActionButtonSx, comparisonFieldSx } from './windowChrome/index.js';
import axios from "axios";

const getFreshModel = () => ({
    first: "",
    middle: "",
    last: "",
    email: "",
    cell: "",
});

const Profile = () => {
    const { clearToken } = useAuth();
    const navigate = useNavigate();
    const [loading, setLoading] = React.useState(false);

    const {
        values,
        errors,
        setErrors,
        handleInputChange
    } = useForm(getFreshModel);



    useEffect(() => {
        const ctask = () => {
            //return global.encryptMessageOutAsync("email", 4096, 4096, 512);
            return createApiEndpoint().fetchProfile("compressed");
        };
        ctask().then((response) => {
            // Check if response is false (which might indicate a 401)
            if (response === false && global.gw.token && global.gw.auth) {
                // Server likely logged us out - throw 401 to trigger interceptor
                const authError = new Error('401 Unauthorized - Server logged out user');
                authError.response = { status: 401 };
                throw authError;
            }
            
            if (response) {
                values.first = response.data.fetchProfile.first;
            }
        }).catch(function (error) {
            // If it's a 401 error, manually trigger the redirect (interceptor only catches axios errors)
            if (error.response && error.response.status === 401) {
                // console.log('Profile: 401 error detected, clearing auth and redirecting to login');
                // Clear authentication state
                clearToken();
                delete axios.defaults.headers.common["Authorization"];
                global.gw.token = null;
                global.gw.auth = null;
                global.gw.isAuthenticated = false;
                // Redirect to login page
                setTimeout(() => {
                    window.location.href = "/emailLogin";
                }, 100);
                return;
            }
            // Also check for error message containing "401"
            if (error.message && (error.message.includes("401") || error.message.includes("Unauthorized"))) {
                // console.log('Profile: Unauthorized error detected, clearing auth and redirecting to login');
                // Clear authentication state
                clearToken();
                delete axios.defaults.headers.common["Authorization"];
                global.gw.token = null;
                global.gw.auth = null;
                global.gw.isAuthenticated = false;
                // Redirect to login page
                setTimeout(() => {
                    window.location.href = "/emailLogin";
                }, 100);
                return;
            }
        });
    }, []);

    const login = async (e) => {
        setLoading(true);
        e.preventDefault();

        //if (validate()) {
        //    if (global.gw.bypass) {
        //        global.gw.token = "test token";
        //        global.gw.auth = "test token";
        //        global.gw.email = values.email.toLowerCase().trimEnd();
        //        //navigate("/sites", { replace: true });
        //    }
        //    else {
        //        let userExists = await createApiEndpoint(global.Endpoints.GrainWave)
        //            .fetchUser(values.email);
        //        if (userExists) {
        //            let windowSize = window.document.getElementsByClassName("windowSize")[0];
        //            if (windowSize) {
        //                global.gw.windowSize = windowSize.getBoundingClientRect();
        //                //alert(`height: ${global.gw.windowSize.height}\ntop: ${global.gw.windowSize.top}\nbottom: ${global.gw.windowSize.bottom}`);
        //            }
        //            //navigate("/");
        //        }
        //    }
        //}

        //if (validate()) {
        //    let userExists = await createApiEndpoint(global.Endpoints.GrainWave)
        //        .fetchLogin(values.wall);

        //    if (userExists) {
        //        let splits = userExists.split("|");
        //        if (splits.length !== 2)
        //            navigate("/");

        //        global.gw.token = splits[0];
        //        global.gw.auth = splits[1];
        //        navigate("/", { replace: true });
        //    }
        //    else {
        //        if (global.gw.bypass) {
        //            global.gw.token = "test token";
        //            global.gw.auth = "test token";
        //            navigate("/dashboard", { replace: true });
        //        }
        //        else {
        //            clearToken();
        //            navigate("/", { replace: true });
        //        }
        //    }
        //}
        setLoading(false);
    };

    const validate = () => {
        let temp = {
            email: "",
            wall: null,
        };
        temp.email = (/\S+@\S+\.\S+/).test(values.email) ? "" : "Email is not valid.";
        temp.wall = values.wall && values.wall !== "" ? "" : "This field is required.";
        setErrors(temp);
        return Object.values(temp).every(x => x === "");
    };

    return (
        <WindowChrome
            title="Profile"
            onClose={() => navigate("/sites")}
            actions={
                <MuiMaterials.LoadingButton
                    type="submit"
                    form="profile-form"
                    loading={loading}
                    variant="outlined"
                    size="small"
                    sx={outlinedActionButtonSx()}
                >
                    Save
                </MuiMaterials.LoadingButton>
            }
        >
            <ModalBody>
                <ModalContentTile
                    sx={{
                        overflowX: "hidden",
                        overflowY: "auto",
                        overscrollBehavior: "contain",
                        WebkitOverflowScrolling: "touch",
                        pt: 2,
                    }}
                >
                    <MuiMaterials.Box
                        component="form"
                        id="profile-form"
                        noValidate
                        onSubmit={login}
                        sx={{
                            display: "grid",
                            width: "100%",
                            gap: 1.5,
                            alignItems: "start",
                            gridTemplateColumns: {
                                xs: "repeat(2, minmax(80px, 1fr))",
                                sm: "repeat(4, minmax(80px, 1fr))",
                                md: "repeat(6, minmax(80px, 1fr))",
                                lg: "repeat(8, minmax(80px, 1fr))",
                            },
                        }}
                    >
                        <MuiMaterials.TextField
                            size="small"
                            value={values.first}
                            label="First"
                            name="first"
                            variant="outlined"
                            sx={{ ...comparisonFieldSx(), gridColumn: "span 2", minWidth: 80, width: "100%" }}
                            onChange={handleInputChange}
                            {...(errors.first && { error: true, helperText: errors.first })}
                        />
                        <MuiMaterials.TextField
                            size="small"
                            label="Middle"
                            name="middle"
                            variant="outlined"
                            sx={{ ...comparisonFieldSx(), gridColumn: "span 2", minWidth: 80, width: "100%" }}
                            onChange={handleInputChange}
                            {...(errors.middle && { error: true, helperText: errors.middle })}
                        />
                        <MuiMaterials.TextField
                            size="small"
                            label="Last"
                            name="last"
                            variant="outlined"
                            sx={{ ...comparisonFieldSx(), gridColumn: "span 2", minWidth: 80, width: "100%" }}
                            onChange={handleInputChange}
                            {...(errors.last && { error: true, helperText: errors.last })}
                        />
                        <MuiMaterials.TextField
                            size="small"
                            label="Email"
                            name="email"
                            variant="outlined"
                            sx={{ ...comparisonFieldSx(), gridColumn: { xs: "1 / -1", md: "span 4" }, minWidth: 80, width: "100%" }}
                            onChange={handleInputChange}
                            {...(errors.email && { error: true, helperText: errors.email })}
                        />
                        <MuiMaterials.TextField
                            size="small"
                            label="Cell"
                            name="cell"
                            variant="outlined"
                            sx={{ ...comparisonFieldSx(), gridColumn: "span 2", minWidth: 80, width: "100%" }}
                            onChange={handleInputChange}
                            {...(errors.cell && { error: true, helperText: errors.cell })}
                        />
                        <MuiMaterials.TextField
                            size="small"
                            label="Password"
                            name="wall"
                            type="password"
                            variant="outlined"
                            sx={{ ...comparisonFieldSx(), gridColumn: "span 2", minWidth: 80, width: "100%" }}
                            onChange={handleInputChange}
                            {...(errors.wall && { error: true, helperText: errors.wall })}
                        />
                    </MuiMaterials.Box>
                </ModalContentTile>
            </ModalBody>
        </WindowChrome>
    );
}

export default Profile;


//{/*value={values.email}*/ }
//value={values.name}